import { BookingDialogActionType } from "../Actions";
import { Direction, IVoucher } from "../Models";
import { ActionType } from "./Actions";
import { IAvailableOptionsForBooking, IManageBookingState, ITableBooking } from "./Model";

export const createReducer = (initialState?: IManageBookingState) => {
	return (state: IManageBookingState = initialState||{}, action: { type: ActionType|BookingDialogActionType }) : IManageBookingState => {
		switch (action.type) {
			// case "hideApp":
			// 	return { appVisible: false }; //{ ...state, ...{ appVisible: false, booking: undefined,  }};
			// case "showApp":
			// 	return {...state, ...{ appVisible: true, bookingNumber: (action as any).bookingNumber, email: (action as any).email, mode: (action as any).mode }};
			case "clearBooking":
				return {...state, ...{ booking: null, bookingNumber: null, email: null }};
			case "findBookingStarted":
				return {...state, ...{ booking: null, bookingNumber: (action as any).meta.bookingNumber, email: (action as any).meta.email }};
			case "findBookingComplete":
				return {...state, ...{ booking: (action as any).payload.booking, authToken: (action as any).payload.authToken, services: (action as any).payload.services }};
			case "loadPassengerTypesComplete":
				return {...state, ...{ passengerTypes: (action as any).payload.items }};
			case "addTableBooking":
				return addTableBooking(state, (action as any).tableBooking);
			case "cancelTableBookingComplete":
				return removeTableBooking(state, (action as any).meta);
			case "verifyVoucherComplete":
				return addVoucher(state, (action as any).payload);
			case "verifyDiscountCodeComplete":
				return addDiscountCode(state, (action as any).payload);
			case "clearDiscountCodes":
				return { ...state, ...{ discountCodes: null }}
			case "startPaymentComplete":
				return { ...state, ...{ payment: (action as any).payload }};
			case "abortPayment":
				return { ...state, ...{ payment: null }};
			case "setCancelModalVisible":
				return { ...state, ...{ showCancelModal: (action as any).visible }};
			case "cancelBookingComplete":
				return updateCancelled(state, (action as any).meta.bookingNumber, (action as any).meta.direction);
			case "loadOptionsComplete":
				return optionsLoaded(state, (action as any).payload);
			case "updateOptionsComplete":
			case "revertChangesComplete":
				return { ...state, ...{ booking: (action as any).payload.booking }};
			case "loadAvailableTimesForSegmentComplete":
				return addAvailableTimes(state, action as any);
			case "bookTableForMealComplete":
				return addTableBookingForMeal(state, (action as any).payload, (action as any).meta);
			default:
				return state;
		}
	};
};

function optionsLoaded(state: IManageBookingState, data: IAvailableOptionsForBooking)
{
	return { ...state, ...{ booking: { ...state.booking, ...{ availableOptions: data } } } };
}

function addVoucher(state: IManageBookingState, voucher: IVoucher): IManageBookingState
{
	let vouchers = state.vouchers ? [...state.vouchers] : [];
	vouchers.push(voucher);
	return {...state, ...{ vouchers} };
}

function addDiscountCode(state: IManageBookingState, voucher: IVoucher): IManageBookingState
{
	let discountCodes = state.discountCodes ? [...state.discountCodes] : [];
	discountCodes.push(voucher);
	return {...state, ...{ discountCodes } };
}

function updateCancelled(state: IManageBookingState, bookingNumber: string, direction: Direction|""): IManageBookingState
{
	if (state.booking?.bookingNumber != bookingNumber)
		return state;

	if (state.booking?.outbound && (direction == "outbound" || direction == ""))
		state = { ...state, ...{ booking: {...state.booking, ...{ outbound: { ...state.booking.outbound,...{ cancelled: true } } } } } };
	if (state.booking?.inbound && (direction == "inbound" || direction == ""))
		state = { ...state, ...{ booking: {...state.booking, ...{ inbound: { ...state.booking.inbound,...{ cancelled: true } } } } } };

	if (state.booking?.outbound?.cancelled && state.booking?.inbound?.cancelled)
		state = { ...state, ...{ booking: { ...state.booking, ...{ cancelled: true } } } };


	return { ...state, ...{ showCancelModal: false } };
}

function addTableBookingForMeal(state: IManageBookingState, booking: ITableBooking, meta: { currentBookingId?: number, temporary: boolean }): IManageBookingState {
	if (!state.booking || !booking)
		return state;

	let isNew = meta.temporary;

	if (meta.currentBookingId) {
		const tableBooking = {...state.booking.tableBooking };
		const oldBooking = tableBooking?.bookings?.find(x => x.bookingId === meta.currentBookingId);
		if (oldBooking)
		{
			tableBooking.bookings = tableBooking.bookings?.filter(x => x.bookingId !== meta.currentBookingId);
			state = { ...state, ...{ booking: { ...state.booking, ...{ tableBooking } }}};
			isNew = oldBooking.isNew; //Om bokningen vi tog bord är prel ska även denna bokning vara prel
		}
	}



	//Vi lägger på en flagga så vi vet att den är nygjord, så kan vi avboka den om vi stänger rutan
	const newBooking = { ...booking, ...{ isNew }};
	return addTableBooking(state, newBooking);
}

function addTableBooking(state: IManageBookingState, booking: ITableBooking): IManageBookingState {
	if (!state.booking || !booking)
		return state;

	const tableBooking = {...state.booking.tableBooking };
	const bookings = tableBooking.bookings ? [...tableBooking.bookings] : [];
	bookings.push(booking);
	tableBooking.bookings = bookings;

	return { ...state, ...{ booking: { ...state.booking, ...{ tableBooking } }}};
}

function removeTableBooking(state: IManageBookingState, meta: { bookingNumber: string, tableBookingId: number }): IManageBookingState {
	if (state.booking?.bookingNumber !== meta.bookingNumber || state.booking.tableBooking?.bookings?.some(x => x.bookingId === meta.tableBookingId) !== true)
		return state;

	const tableBooking = {...state.booking.tableBooking };
	tableBooking.bookings =  tableBooking.bookings.filter(x => x.bookingId !== meta.tableBookingId);

	return { ...state, ...{ booking: { ...state.booking, ...{ tableBooking } }}};
}

function addAvailableTimes(state: IManageBookingState, action: { meta: { bookingNumber: string, segmentId: string, optionCode: string }, payload: { items: string[], date: string }})
{
	if (state.booking?.bookingNumber !== action.meta.bookingNumber)
		return state;

	let direction : Direction;
	if (state.booking.outbound?.segments.some(x => x.segmentId === action.meta.segmentId) === true)
		direction = "outbound";
	else if (state.booking.inbound?.segments.some(x => x.segmentId === action.meta.segmentId) === true)
		direction = "inbound";

	if (!direction)
		return state;


	const tableBooking = {...state.booking.tableBooking };
	const availableTimes = {...tableBooking.availableTimes};
	const availableTimesForSegment = [...(availableTimes[action.meta.segmentId] || [])];

	// availableTimesForLeg[action.meta.productCode] = action.payload.items;

	const index = availableTimesForSegment.findIndex(x => x.productCode === action.meta.optionCode);
	const obj = { productCode: action.meta.optionCode, times: action.payload.items, date: action.payload.date };
	if (index >= 0)
		availableTimesForSegment[index] = obj;
	else
		availableTimesForSegment.push(obj)

	availableTimes[action.meta.segmentId] = availableTimesForSegment;

	return {...state, ...{
		booking: {
			...state.booking, ...{
				tableBooking: { ...state.booking.tableBooking, ...{ availableTimes } }
			}
		}
	}};
}